var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Billing",attrs:{"id":"App"}},[_c('BillingLists',{attrs:{"showCustomerId":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }